import type { VehicleTemplateEntity } from '@/features/vehicleTemplate/domain/entities/VehicleTemplateEntity'
import type { DriverAppDevicePlatform } from '../enums/DriverAppDevicePlatform'
import type { DriverAppType } from '../enums/DriverAppType'
import type { DriverTeamEntity } from '@/features/driverTeam/domain/entities/DriverTeamEntity'
export class DriverTrackingEntity {
  id?: number
  workingPhoneNumber?: string | null
  fullName?: string | null
  avatarImagePath?: string | null
  regionId?: number
  regionName?: string | null
  vehicleTemplate?: VehicleTemplateEntity
  deviceName?: string | null
  devicePlatform?: DriverAppDevicePlatform
  appType?: DriverAppType
  appVersion?: string | null
  driverTeams?: DriverTeamEntity[]
}
